export enum AvailabilityMacroStatus {
    PLANNED = 'PLANNED',
    AVAILABLE = 'AVAILABLE',
    BUSY = 'BUSY',
    UNUSABLE = 'UNUSABLE',
    UNKNOWN = 'UNKNOWN',
}

export enum NetworkAvailabilityMacroStatus {
    PLANNED = 'PLANNED',
    AVAILABLE = 'AVAILABLE',
    AVAILABLE_SECONDARY = 'AVAILABLE_SECONDARY',
    AVAILABLE_TERTIARY = 'AVAILABLE_TERTIARY',
    BUSY = 'BUSY',
    UNUSABLE = 'UNUSABLE',
    UNKNOWN = 'UNKNOWN',
}

// Unfortunately, cannot assign multiple values to an enum in TS.
// Could have been prettier if AvailabilityMacroStatus was a class.
/**
 * Return priority level (with 0 being the lowest priority) based on the availability macro status.
 * Useful when you want to sort infra elements by their availability status.
 */
export function getPriorityOfAvailabilityMacroStatus(availabilityMacroStatus: AvailabilityMacroStatus): number {
    switch (availabilityMacroStatus) {
        case AvailabilityMacroStatus.AVAILABLE:
            return 40;
        case AvailabilityMacroStatus.BUSY:
            return 30;
        case AvailabilityMacroStatus.UNUSABLE:
            return 20;
        case AvailabilityMacroStatus.UNKNOWN:
            return 10;
        default:
            return 0;
    }
}
